import { render, staticRenderFns } from "./EcManage.vue?vue&type=template&id=db08706c&scoped=true&"
import script from "./EcManage.vue?vue&type=script&lang=js&"
export * from "./EcManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db08706c",
  null
  
)

export default component.exports